// As strings do voucher de ônibus no esqueleto novo (`buildBusVoucherView`, #5031), em
// arquivo próprio pelo mesmo motivo do `flight_voucher_catalog.ts`: o catálogo principal tem
// teto de 500 linhas. O `CATALOG` espalha estas três por cima das dele.
const PT_BR = {
  'trips.busVoucher.dates.one': 'Viagem · {{date}}',
  'trips.busVoucher.dates.many': 'Viagens · {{range}}',
  'trips.busVoucher.seat': 'Poltrona {{seat}}',
  'trips.busVoucher.seats_one': '{{count}} assento',
  'trips.busVoucher.seats_other': '{{count}} assentos',
};

const EN: Record<keyof typeof PT_BR, string> = {
  'trips.busVoucher.dates.one': 'Trip · {{date}}',
  'trips.busVoucher.dates.many': 'Trips · {{range}}',
  'trips.busVoucher.seat': 'Seat {{seat}}',
  'trips.busVoucher.seats_one': '{{count}} seat',
  'trips.busVoucher.seats_other': '{{count}} seats',
};

const ES: Record<keyof typeof PT_BR, string> = {
  'trips.busVoucher.dates.one': 'Viaje · {{date}}',
  'trips.busVoucher.dates.many': 'Viajes · {{range}}',
  'trips.busVoucher.seat': 'Asiento {{seat}}',
  'trips.busVoucher.seats_one': '{{count}} asiento',
  'trips.busVoucher.seats_other': '{{count}} asientos',
};

export const BUS_VOUCHER_CATALOG = { 'pt-BR': PT_BR, en: EN, es: ES };
